export default __webpack_public_path__ + "static/media/equities.dbaef841.svg";